export const STATISTICS_DATA_REQUEST = "STATISTICS_DATA_REQUEST";
export const STATISTICS_DATA_SUCCESS = "STATISTICS_DATA_SUCCESS";
export const STATISTICS_DATA_FAILURE = "STATISTICS_DATA_FAILURE";
